// extracted by mini-css-extract-plugin
export default {"main":"Header_main__iJ2Fx","container":"Header_container__Pv0TG","logo":"Header_logo__eQM7L"};